import React from 'react'
import orderBy from 'lodash/orderBy'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemIcon from '@material-ui/core/ListItemIcon'

import { Icon } from 'src/chrome'

import { SearchFilter } from '../types'

type Props = {
  filters: SearchFilter[]
  highlightIndex: number | undefined
  onSelect: (filter: SearchFilter) => void
  onClick: () => void
}

const FilterList: React.FC<Props> = props => {
  const { filters, highlightIndex, onSelect, onClick } = props

  return (
    <div
      style={{
        maxHeight: 300,
        overflow: 'auto',
        width: 200,
      }}
      /* onMouseDown / onTouchStart is necessary to capture the click before onBlur
         hides the content of this element */
      onMouseDown={onClick}
      onTouchStart={onClick}
    >
      <List>
        {orderBy(filters, 'name').map((filter, index) => {
          return (
            /* onMouseDown / onTouchStart is necessary to capture the click before onBlur
             hides the content of this element */
            <div
              id={`filter_chip_${filter.name.split(' ')[0].toLowerCase()}`}
              key={filter.name}
              onMouseDown={() => onSelect(filter)}
              onTouchStart={() => onSelect(filter)}
            >
              <ListItem
                data-index={index}
                style={{
                  cursor: 'pointer',
                  background: index === highlightIndex ? '#eee' : '',
                }}
                onClick={() => onSelect(filter)}
                onSelect={() => onSelect(filter)}
              >
                {filter.icon && (
                  <ListItemIcon>
                    <Icon
                      icon={filter.icon.svg}
                      size={filter.icon.size}
                      color={filter.icon.color}
                      viewBox={filter.icon.viewBox}
                    />
                  </ListItemIcon>
                )}
                <ListItemText primary={filter.name} />
              </ListItem>
            </div>
          )
        })}
      </List>
    </div>
  )
}

export default FilterList
